import { render } from "./CorrectTwoView.vue?vue&type=template&id=100922fb&ts=true"
import script from "./CorrectTwoView.vue?vue&type=script&lang=ts"
export * from "./CorrectTwoView.vue?vue&type=script&lang=ts"

import "./CorrectTwoView.vue?vue&type=style&index=0&id=100922fb&lang=scss"

import exportComponent from "C:\\vue项目\\baiduobang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__